export const FacebookIcon = () => {
  return (
    <svg
      width={18}
      height={21}
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.487.75H10.43c-1.814 0-3.832.778-3.832 3.459.01.934 0 1.828 0 2.835H4.5v3.405h2.163v9.801h3.976v-9.866h2.624l.237-3.35h-2.93s.007-1.49 0-1.922c0-1.06 1.081-.999 1.146-.999.515 0 1.515.002 1.772 0V.75h-.001z"
        fill="#697484" // is changing to #fff by hover
      />
    </svg>
  )
}